import List from './List';
import Create from './Create';
import Edit from './Edit';
import Show from './Show';
import { gql } from '@apollo/client';

export default {
  name: 'VmsPosition',
  inputShow: gql`
    query vmsPositions($input: VmsPositionQueryInput) {
      vmsPositions(input: $input) {
        id
        label
        __typename
      }
    }
  `,
  list: List,
  create: Create,
  edit: Edit,
  show: Show,
  options: {
    group: 'VMS',
    label: 'VMS Positions',
  },
};
